module.exports = __webpack_public_path__ + "img/euro.08264ff0.svg";